import { createFileRoute, Outlet } from "@tanstack/react-router";

import { AppShell } from "../components/AppShell";

export const Route = createFileRoute("/chats")({
  component: ChatsLayout,
});

function ChatsLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
